import httpV2 from '@/utils/httpV2';
import dictUtil from '@/utils/dictionaryUtil';

const state = {

};
const getters = {};

const mutations = {};

const actions = {    
    
    getAnalyticsEvents({ state, commit }, params) {
        let promise = httpV2.post(process.env.VUE_APP_SDP + '/v1.0/analytics/events/page', params, this);
        return promise;
    },

  

};
export default {
    getters,
    state,
    mutations,
    actions
};
